var map = {
	"./BrandsLogo/alta-component.svg": "07ea",
	"./BrandsLogo/alvaro-component.svg": "64eb",
	"./BrandsLogo/antonello-component.svg": "80ff",
	"./BrandsLogo/atalaia-component.svg": "90ac",
	"./BrandsLogo/bacellar-component.svg": "67e0",
	"./BrandsLogo/bioclinico-component.svg": "a775",
	"./BrandsLogo/boris-berenstein-component.svg": "13a5",
	"./BrandsLogo/bronstein-component.svg": "99c2",
	"./BrandsLogo/cdpi-niteroi-component.svg": "f5f3",
	"./BrandsLogo/cdpi-rio-component.svg": "0f4c",
	"./BrandsLogo/cec-component.svg": "cbef",
	"./BrandsLogo/cedic-cedilab-component.svg": "0e46",
	"./BrandsLogo/cerpe-component.svg": "4cee",
	"./BrandsLogo/cytolab-component.svg": "25bd",
	"./BrandsLogo/delboni-component.svg": "13ef",
	"./BrandsLogo/deliberato-component.svg": "705e",
	"./BrandsLogo/elcordis-component.svg": "2bae",
	"./BrandsLogo/exame-component.svg": "775e",
	"./BrandsLogo/exame-do-sul-component.svg": "2763",
	"./BrandsLogo/frischmann-component.svg": "0cf5",
	"./BrandsLogo/ghanem-component.svg": "ea9e",
	"./BrandsLogo/gilson-cidrim-component.svg": "bf2c",
	"./BrandsLogo/image-component.svg": "69f2",
	"./BrandsLogo/itulab-component.svg": "3aa6",
	"./BrandsLogo/labpasteur-component.svg": "822e",
	"./BrandsLogo/lamina-component.svg": "4617",
	"./BrandsLogo/lamina-sc-component.svg": "98e9",
	"./BrandsLogo/lavoisier-component.svg": "23ce",
	"./BrandsLogo/leme-component.svg": "7b24",
	"./BrandsLogo/lunav-component.svg": "c189",
	"./BrandsLogo/lustosa-component.svg": "8b24",
	"./BrandsLogo/multi-imagem-component.svg": "fe0d",
	"./BrandsLogo/oswaldo-cruz-component.svg": "aa57",
	"./BrandsLogo/padrao-component.svg": "bb2a",
	"./BrandsLogo/previlab-component.svg": "c4c0",
	"./BrandsLogo/salomao-zoppi-component.svg": "3d6c",
	"./BrandsLogo/santa-luzia-component.svg": "33fe",
	"./BrandsLogo/sao-camilo-component.svg": "c2ae",
	"./BrandsLogo/sao-marcos-component.svg": "e8d7",
	"./BrandsLogo/senhor-dos-passos-component.svg": "8c0e",
	"./BrandsLogo/sergio-franco-component.svg": "b0a6",
	"./BrandsLogo/unimed-cuiaba-component.svg": "6d8d",
	"./BrandsLogo/valeclin-component.svg": "d9cd",
	"./BrandsLogo/vital-brasil-component.svg": "4722",
	"./amil-icon-component.svg": "41bd",
	"./arrival-component.svg": "d2e9",
	"./attention-component.svg": "9424",
	"./beaker-large-component.svg": "b3f1",
	"./card-logo-american-express-component.svg": "1786",
	"./card-logo-diners-club-component.svg": "cf63",
	"./card-logo-elo-component.svg": "21de",
	"./card-logo-hiper-component.svg": "b0e6",
	"./card-logo-hipercard-component.svg": "34c7",
	"./card-logo-mastercard-component.svg": "0b0f",
	"./card-logo-visa-component.svg": "9c15",
	"./circle-icon-add-component.svg": "c483",
	"./circle-icon-labExam-component.svg": "a72d",
	"./circle-icon-payments-component.svg": "4d45",
	"./copy-paste-component.svg": "aee0",
	"./credit-card-component.svg": "f274",
	"./dasa-logo-component.svg": "7e95",
	"./icon-email-component.svg": "be3c",
	"./icon-phone-component.svg": "2a34",
	"./icon-service-component.svg": "add9",
	"./icons/alert-circle-component.svg": "7d61",
	"./icons/alert-circle-stroke-component.svg": "ab20",
	"./icons/arrow-right-component.svg": "8eda",
	"./icons/arrows/arrow-header-grey-component.svg": "177d",
	"./icons/attendant-component.svg": "e2a6",
	"./icons/beaker-component.svg": "8f42",
	"./icons/bulb-component.svg": "4536",
	"./icons/calendar-component.svg": "6cd1",
	"./icons/calendar-plus-component.svg": "233e",
	"./icons/card-credit-component.svg": "5a2d",
	"./icons/cart-component.svg": "22c1",
	"./icons/cart-fill-component.svg": "e652",
	"./icons/cel-component.svg": "c9ed",
	"./icons/check-circle-component.svg": "0006",
	"./icons/check-component.svg": "d9d5",
	"./icons/check-icon-component.svg": "c768",
	"./icons/chevron-down-component.svg": "d4c6",
	"./icons/chevron-up-component.svg": "d077",
	"./icons/clock-component.svg": "a5a3",
	"./icons/close-component.svg": "876a",
	"./icons/credit-card-component.svg": "11b9",
	"./icons/custom-check-component.svg": "8db1",
	"./icons/document-component.svg": "237c",
	"./icons/error-circle-component.svg": "d209",
	"./icons/file-component.svg": "7acf",
	"./icons/file-name-broken-component.svg": "a3b2",
	"./icons/file-name-component.svg": "4f27",
	"./icons/file-text-component.svg": "1530",
	"./icons/health-insurance-component.svg": "1354",
	"./icons/heart-beating-component.svg": "d114",
	"./icons/hospital-component.svg": "a0b1",
	"./icons/hospital-stroke-component.svg": "d614",
	"./icons/insuranceCard-component.svg": "f13b",
	"./icons/letter-component.svg": "f821",
	"./icons/mail-component.svg": "c48f",
	"./icons/medical-request-component.svg": "122f",
	"./icons/note-component.svg": "343e",
	"./icons/patient-component.svg": "3092",
	"./icons/pin-component.svg": "1f6a",
	"./icons/pin-stroke-component.svg": "c043",
	"./icons/plus-component.svg": "66d6",
	"./icons/print-component.svg": "9a89",
	"./icons/save-mobile-component.svg": "9867",
	"./icons/search-component.svg": "10ee",
	"./icons/sms-component.svg": "b743",
	"./icons/star-component.svg": "9c61",
	"./icons/star-filled-component.svg": "b8de",
	"./icons/success-circle-component.svg": "df20",
	"./icons/team-component.svg": "db80",
	"./icons/three-dots-component.svg": "bf63",
	"./icons/ticket-component.svg": "62d7",
	"./icons/trash-component.svg": "de14",
	"./icons/user-component.svg": "eda2",
	"./icons/wallet-component.svg": "6ace",
	"./icons/write-component.svg": "eb4a",
	"./instrucao-atendente-prd-component.svg": "f0e4",
	"./nav-logo-component.svg": "9c27",
	"./nav-logo-white-component.svg": "6934",
	"./padlock-component.svg": "c938",
	"./pix-icon-component.svg": "b052",
	"./spinner-component.svg": "dc74",
	"./star-filled-component.svg": "acff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9e1";